import MultiQuoteActions from "@redux/feature/TOCJourney/actions/MultiQuoteActions";
import PlaceNormalTradeActions from "@redux/feature/TOCJourney/actions/PlaceNormalTradeActions";
import OrderDetailsActions from "@redux/feature/TOCJourney/actions/OrderDetailsActions";
import CheckMarginActions from "@redux/feature/TOCJourney/actions/CheckMarginActions";
import BrokerChargesActions from "@redux/feature/TOCJourney/actions/BrokerChargesActions";
import RMSDetailsActions from "@redux/feature/TOCJourney/actions/RmsDetails";
import AMOStatusActions from "@redux/feature/TOCJourney/actions/AMOStatusActions";
import ProceedToAuthActions from "@redux/feature/TOCJourney/actions/ProceedToAuth";
import LimitsActions from "@redux/feature/TOCJourney/actions/LimitsAction";
import MFParticularHoldingActions from "@redux/feature/TOCJourney/actions/MFParticularHoldings";
import UserStatusActions from "@redux/feature/TOCJourney/actions/UserStatusActions";
import UPIListActions from "@redux/feature/TOCJourney/actions/UPIListActions";
import IpobankMasterActiton from "@redux/feature/TOCJourney/actions/IpobankMasterActiton";
import IpoOtpValidateActiton from "@redux/feature/TOCJourney/actions/IpoOtpValidateAction";
import IpoOtpRegisterActiton from "@redux/feature/TOCJourney/actions/IpoOtpRegisterActions";
import IpoOtpLeadsActiton from "@redux/feature/TOCJourney/actions/IpoOtpLeadsActions";
import IpoCancelActiton from "@redux/feature/TOCJourney/actions/IpoCancelAction";
export default (function () {
    return {
        tocJourney: {
            multiQuoteActions: new MultiQuoteActions(),
            placeNormalTrade: new PlaceNormalTradeActions(),
            placeOfsTrade: new PlaceNormalTradeActions(),
            placeTradeComm: new PlaceNormalTradeActions(),
            orderDetails: new OrderDetailsActions(),
            checkMargin: new CheckMarginActions(),
            brokerCharges: new BrokerChargesActions(),
            brokerChargesComm: new BrokerChargesActions(),
            rmsDetails: new RMSDetailsActions(),
            amoStatus: new AMOStatusActions(),
            proceedToAuth: new ProceedToAuthActions(),
            limits: new LimitsActions(),
            mfParticularHolding: new MFParticularHoldingActions(),
            userStatus: new UserStatusActions(),
            upiList: new UPIListActions(),
            IpoBankMaster: new IpobankMasterActiton(),
            IpoOtpValidate: new IpoOtpValidateActiton(),
            IpoOtpRegister: new IpoOtpRegisterActiton(),
            IpoOtpLeads: new IpoOtpLeadsActiton(),
            IpoCancel: new IpoCancelActiton(),
        },
    };
});
